import axios from "axios";
import { Config } from "../../data/config";

export const SET_PROMOTION = "PROMOTION | SET_PROMOTION";
export const RESET_PROMOTION = "PROMOTION | RESET_PROMOTION";

export function fetchPromotions(bid) {
  return function (dispatch) {
    axios
      .get(`${Config.frontApiUrl}/onboarding/promo/${bid}`)
      .then(response => {
        dispatch(setPromotions(response.data));
      });
  };
}

export function setPromotions(data) {
  return { type: SET_PROMOTION, payload: data };
}

export function resetPromotions() {
  return { type: RESET_PROMOTION };
}



// WEBPACK FOOTER //
// ./src/store/actions/promotion.js